import { Component, Inject, Input } from '@angular/core';
import { TOAST_DATA_INJECTION_TOKEN, ToastBaseComponent, ToastDataBaseComponent } from '../toast-base.component';
import { BasicNotification } from 'src/app/notifications/models/basic-notification';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';
import { isInternalUrl } from 'src/app/shared/helpers/url-helper';

@Component({
  selector: 'app-toast',
  templateUrl: './notification-toast.component.html',
  styleUrls: ['./notification-toast.component.scss'],
  standalone: false
})
export class NotificationToastComponent extends ToastBaseComponent<NotificationToastDataComponent> {
  constructor(
    @Inject(TOAST_DATA_INJECTION_TOKEN) public data: NotificationToastDataComponent,
    private router: Router,
  )
  {
      super(data);
  }

  navigateToLink(url: string) {
    if (isInternalUrl(url)) {
      this.router.navigateByUrl(url);
    } else {
      window.location.href = url;
    }
  }

  dismiss() {
    this.data.host.dismissToast(this.data.index);
  }
}

export class NotificationToastDataComponent extends ToastDataBaseComponent {
  notification: BasicNotification;
}
